var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "login-form"
  }, [_c('div', {
    staticClass: "center-box"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "login-left"
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "rule-form",
    attrs: {
      "span": 12
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    key: _vm.transitionKey,
    staticClass: "transition-wrap"
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "projects": _vm.options
    },
    on: {
      "change": _vm.trans,
      "success": _vm.successLogin
    }
  })], 1)])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    attrs: {
      "src": require("./images/login-logo.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v(_vm._s(_vm.copyrightText))]), _vm._v(" "), _c('p', {
    staticClass: "ml-10",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "href": _vm.icpLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.icpText))])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "top": "-50px",
      "position": "absolute"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/logo-text.png"),
      "alt": "netease"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f55f66"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
// module id = null
// module chunks = 